<template>
  <a-card :bordered="false" title="预约商品">
    <custom-page-table
      ref="table"
      :columns="getColumns()"
      :queryParams="queryParams"
      params-path="reserve/selectReservePro"
      base-key="conponUrl"
    >
      <template slot="customIndex" slot-scope="rowItem">{{ rowItem.index + 1 }}</template>
      <template slot="action" slot-scope="rowItem">
        <a @click="toLink(rowItem.record)">查看链接</a>
      </template>
    </custom-page-table>
  </a-card>
</template>

<script>
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'CouponProductList',
  components: {},
  data() {
    return {
      queryParams: {}
    }
  },
  mounted() {
  },
  methods: {
    toLink(item) {
      let url = item.url
      if (url.indexOf('http') === -1) {
        url = 'https://' + url
      }
      const merchantId = this.$store.getters.userInfo.merchantId
      let params = {
        type: 83,
        proId: item.proId,
        orderType: 3,
        p: `${1}_${merchantId}_${merchantId}`
      }
      let pathUrl = RouterSwitchHelper.getTargetUrl(url, params)
      window.open(pathUrl)
    },
    getColumns() {
      return [
        {
          title: '序号',
          dataIndex: 'customIndex',
          scopedSlots: { customRender: 'customIndex' }
        },
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '名称',
          dataIndex: 'proName',
          width: '35%'
        },
        {
          title: '库存',
          dataIndex: 'stock'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '130px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped>
</style>